import "./App.less";
import React, { Suspense, useEffect, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import moment from "moment";
import "moment/locale/id";

import { useDispatch, useSelector } from "react-redux";

import routes from "./routes";
import OrganismLayout from "./components/organism/layout";
import NotFound from "./pages/auth/not-found";

import LoginPage from "./pages/auth/login";
import ForgotPassword from "./pages/auth/forgot-password";
import UpdatePassword from "./pages/auth/update-password";
import LoadingSpinner from "./components/loading-spinner";
import { getTokenFcm } from "./config/firebase";
import { fetchAllNotifications } from "./stores/masterData/actions";
import { generateErrorMessage, sendGetRequest } from "./services/request-adapter";
import { message } from "antd";
import Maintenance from "./pages/maintenance/maintenance";

const App = () => {
  const dispatch = useDispatch();

  const currentPathname = window.location.pathname;
  const isValidRoute = routes.map((el) => el.isValid);

  const { token, isLoggedIn } = useSelector((state) => state.auth);

  useEffect(() => {
    getTokenFcm();
    token && isLoggedIn && dispatch(fetchAllNotifications());
  }, []);

  return (
    <Suspense fallback={<LoadingSpinner size="large" />}>
      {token && isLoggedIn ? (
        <OrganismLayout withoutSider={!isValidRoute}>
          <Routes>
            {routes?.map((el, idx) => (
              <Route
                key={idx}
                path={el.path}
                element={
                  <el.element
                    dispatch={dispatch}
                    useEffect={useEffect}
                    useState={useState}
                    moment={moment}
                  />
                }
              />
            ))}
            <Route path="*" element={<NotFound />} />
            <Route path="/maintenance" element={<Maintenance />} />
          </Routes>
        </OrganismLayout>
      ) : (
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/update-password" element={<UpdatePassword />} />
          <Route path="/" element={<Navigate replace to="/login" />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      )}
    </Suspense>
  );
};

export default App;
